import { dateSeparator } from '../types/date-separator.type';
import { isValidDate } from './is-valid-date.util';

export const isValidCompetenceDate = (
  competenceDate: string,
  separator: dateSeparator = '-',///'/',
  yearFirst = true//false
): boolean => {
  if (competenceDate.length < 7) {
    return false;
  }

  if(competenceDate.indexOf('-') >=0){
    separator = '-';
    yearFirst = true;
  }else{
    separator = '/';
    yearFirst = false;
  }
  const values = competenceDate.split(separator);

  const month = yearFirst ? values[1] : values[0];

  const year = yearFirst ? values[0] : values[1];

  const date = `${year}${separator}${month}${separator}01`;
  return isValidDate(date, separator, true);
};
